import Select, { type Props as SelectProps, type GroupBase } from 'react-select';
import { components, type InputProps } from 'react-select';
import styles from './styles.module.scss';

/**
 * Custom Input that keeps text visible even when a value is selected.
 * Works with controlShouldRenderValue={false}.
 */
export function CustomInput<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(props: InputProps<Option, IsMulti, Group>) {
  return <components.Input {...props} isHidden={false} />;
}

export type SearchSelectProps<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
> = SelectProps<Option, IsMulti, Group>;

export function SearchSelect<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(props: SearchSelectProps<Option, IsMulti, Group>) {
  return (
    <div className={styles.searchSelect}>
      <Select<Option, IsMulti, Group>
        classNamePrefix="rs"
        components={{
          Input: CustomInput,
          DropdownIndicator: null,
          IndicatorSeparator: null,
          ...props.components,
        }}
        isClearable
        isSearchable
        controlShouldRenderValue={false}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        {...props}
      />
    </div>
  );
}
